/**
 * Firestore stores the same download URL when a file is replaced; browsers cache by URL.
 * Append a version from updatedAt/createdAt so clients fetch the latest image after edits.
 */
function timestampVersion(product) {
  if (!product) return ''
  const t = product.updatedAt || product.createdAt
  if (t && typeof t.seconds === 'number') return String(t.seconds)
  if (t && typeof t.toMillis === 'function') return String(t.toMillis())
  if (typeof t === 'string' || typeof t === 'number') return String(t)
  return ''
}

/**
 * Raw image URL from product document (supports legacy field names).
 */
export function getProductImageRaw(product) {
  if (!product) return ''
  const raw =
    product.image ||
    product.productImage ||
    product.photoUrl ||
    product.photoURL ||
    ''
  return typeof raw === 'string' ? raw.trim() : ''
}

/**
 * Image URL safe for <img src>, with cache-bust when timestamps exist.
 */
export function getProductImageUrl(product) {
  const raw = getProductImageRaw(product)
  if (!raw) return ''
  const v = timestampVersion(product)
  if (!v) return raw
  const sep = raw.includes('?') ? '&' : '?'
  return `${raw}${sep}cb=${encodeURIComponent(v)}`
}
